<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>    
    <div>
      <div v-if="loading">
        <div class="text-center">
          <v-progress-linear
            color="info"
            height="10"
            indeterminate
            striped
          ></v-progress-linear>
        </div>
      </div>
      <template v-else>
        <div class="vuse-content-wrapper" v-if="!dialog_setup" >
          <v-card-title primary-title class="pt-0 pb-2">
            <div class="text-h5"><span @click="C=null">Impostazioni </span><span>{{C?' : '+ C.title:''}}</span></div>
            <v-spacer></v-spacer>
              <v-tooltip top v-if="!C">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>
              <!--
              <v-tooltip top v-if="!C">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_setup=true">
                    <v-icon color="error">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Setup</span>
              </v-tooltip>
              -->                
              <v-tooltip top v-if="!items">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_tutorial=true">
                    <v-icon color="info">mdi-cast-education</v-icon>
                  </v-btn>
                </template>
                <span>Tutorial</span>
              </v-tooltip>
              <v-tooltip top v-if="settings.level>100">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_setup=true">
                    <v-icon color="info">mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <span>Setup</span>
              </v-tooltip>  
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="C=null">
                    <v-icon color="info">mdi-view-list</v-icon>
                  </v-btn>
                </template>
                <span>Elenco</span>
              </v-tooltip>                                          
          </v-card-title>
          <v-row v-if="!items">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
          </v-row>          
          <div fluid class="mx-lg-2 px-sm-0" v-else>
            <v-sheet v-if="validSettingsPassword||settings.options.settingsPasswordRequired=='0'">
              <v-row v-if="!C" class="neu-glow pa-3 mt-2">
                <v-col cols="12" sm="6" md="4" lg="2" class="pa-1" v-for="(t,ti) in items" :key="ti">
                  <template>
                    <v-card class="neu-glow ma-1">
                      <v-avatar
                        :color="t.color"
                        size="30"
                      >
                        <span class="white--text">{{ti+1}}</span>
                      </v-avatar>
                      <v-card-text style="min-height:130px">
                        <p class="text-h5 text--primary text-center ">
                          {{t.title}}
                        </p>
                      </v-card-text>
                      <div class="text-center">
                        <v-divider class="info mb-3 mx-5"></v-divider>
                        <v-btn v-if="!t.level" @click="activateComponent(t)" color="info" class="px-3 mb-5">
                          Modifica
                        </v-btn>
                        <v-btn :to="'../shop'" v-else color="warning" class="px-3 mb-5">
                          Abilita
                        </v-btn>
                      </div>
                    </v-card>
                  </template>
                </v-col>
              </v-row>
              <v-row v-else class="background">
                <v-col cols="12" :md="Math.max(12/C.components.length,C.min)" v-for="(c,ci) in C.components" :key="ci" :class="ci==1%2?'py-2 pr-3':'pl-3 py-2'">
                  <v-card flat class="background">
                    <component :is="c"></component>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </div>
        </div>
      </template>
    </div>
    <dialog-instruction v-model="dialog_instruction" />
    <dialog-tutorial v-model="dialog_tutorial"  />
    <dialog-connection-error :number="settings.phoneTechnician" v-model="dialog_connection_error" />
    <dialog-setup @save="saveItem" :loading="loading" v-model="dialog_setup" />
    <dialog-PasswordSettings @checkPwd="checkPWD" :loading="loading" v-model="dialog_passwordSettings" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import allSlots                     from "./Partials/AllSlots";
import promo                        from "./Partials/Promo";
import allSlotsParametersGlobal     from "./Partials/AllSlotsParameters_Global";
import allTables                    from "./Partials/AllTables";
//import allTables                    from "../Canvas/Canvas";
import allCombinations              from "./Partials/AllCombinations";
import allLocationsTable            from "./Partials/AllLocationsTable";
import allHallsTable                from "./Partials/AllHallsTable";
import allMealsTable                from "./Partials/AllMealsTable";
import allShiftsTable               from "./Partials/AllShiftsTable";
import allOptions                   from "./Partials/AllOptions";
import allModules                   from "./Partials/AllModules"
import closedWeekly                 from "./Partials/ClosedWeekly";
import closedPeriods                from "./Partials/ClosedPeriods";
import account                      from "./Partials/Account";
//import invoices                     from "./Partials/Invoices";
import invoices                     from "./Partials/Invoice";
import pictures                     from "./Partials/Pictures";
import logos                        from "./Partials/Logos";
import allFaqs                      from "./Partials/AllFAQS";
import allRequests                  from "./Partials/AllRequests";
import allFoodStyle                 from "./Partials/AllFoodStyle";
import allSlotsParametersExceptions from "./Partials/AllSlotsParametersExceptions";
import allSlotsParameters           from "./Partials/AllSlotsParameters";
import allSlotsParametersGlobal2    from "./Partials/AllSlotsParameters_Global2";
import allHostnames                 from "./Partials/AllHostnames";
import whatsApp                     from "./Partials/WhatsApp";
import directBooking                from "./Partials/DirectBooking";
import subUsers                     from "./Partials/SubUsers";
import voiceMail                    from "./Partials/VoiceMail";
import avatarAI                     from "./Partials/AvatarAI";
import iReview                      from "./Partials/iReview";
import bulkWA                       from "./Partials/bulkWA";
import canvasHall                   from "./Partials/CanvasHall";
import newsletter                   from "./Partials/Newsletter";
import stripeSettings               from "./Partials/StripeSettings";
import dialogInstruction            from "./Dialogs/instruction";
import dialogTutorial               from "./Dialogs/tutorial"
import dialogConnectionError        from "./Dialogs/connectionError"
import dialogSetup                  from "./Dialogs/initialSetup"
import dialogPasswordSettings       from "./Dialogs/settingsPassword"

/*
import tablesByCovers from "./Partials/TablesByCovers";*/
export default {
  components: { allSlots, allSlotsParametersGlobal, allTables, allCombinations, allLocationsTable, allHallsTable, allMealsTable, allShiftsTable, allOptions, allRequests, allFoodStyle,
                allFaqs, allModules, closedWeekly, closedPeriods, account, invoices, logos, pictures, allSlotsParametersExceptions,allSlotsParameters,allSlotsParametersGlobal2,allHostnames, dialogInstruction,dialogTutorial,
                dialogConnectionError,dialogSetup,subUsers,voiceMail,avatarAI,whatsApp,directBooking,promo,iReview,dialogPasswordSettings,bulkWA,canvasHall,newsletter,stripeSettings
              },
  computed :{
      ...mapGetters(["settings"]),
  },
  data() {
    return {
      page: "Settings",
      loading:true,
      errorNumber:'3203023832',
      dialog_setup:true,
      dialog_instruction:false,
      dialog_tutorial:false,
      dialog_connection_error:false,
      dialog_passwordSettings:true,
      snackbar_message:null,
      snackbar_color:null,
      snackbar:false,
      tab:null,
      C:null,
      items:null,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      editedItem2:null,
      accountId:null,
      validSettingsPassword:false,
      pageId:null,

      //pageId:null
      };
    },
    created(){
      this.$vuetify.theme.dark = true;
      console.log(182,this.$route.query.pageId,this.settings.refreshRate);
      this.pageId=this.$route.query.pageId;
      /*if (this.settings&&!this.settings.refreshRate)
      {
        this.$router.push('/auth/login').catch(() => {});
      }
      else*/
      {
        this.getData('a')
        //this.$store.dispatch("setUser",JSON.parse(localStorage.getItem('user')));
      }      
    },
    methods:
    {
      activateComponent(c)
      {
        console.log(219,this.pageId)
        this.validSettingsPassword=this.pageId=='services'||this.validSettingsPassword
        if(this.settings.options.settingsPasswordRequired=='1'&&!this.validSettingsPassword&&!this.dialog_setup)
        {
          this.dialog_passwordSettings=true;
        }
        else
        {
          if (this.validSettingsPassword||this.settings.options.settingsPasswordRequired=='0'||this.dialog_setup)
          {
            console.log(200,c)
            this.dialog_passwordSettings=false;
            this.C=c;
            console.log(202,this.C, this.C.components)
          }
        }
      },
      async getData(origin)
      {
        this.loading=true;
        try{
            //const payload=JSON.stringify({"action":"AllLocationsTable_get"});
            const payload=JSON.stringify({"action":"SettingsWindows_get"});
            const res = await this.$http.post('/settings/settings.php', payload );
            console.log(275,res);            
            switch (res.data.errorid)
            {
              case '0':
                  sessionStorage.setItem('jwt', res.data.jwt);
                  this.accountId=res.data.payloads.settingsWindows[0].accountId
                  this.settings.accountId=this.accountId;
                  this.items=res.data.payloads.settingsWindows;
                  this.dialog_setup=this.items[0].setup?false:true;
                  this.loading=false;
                  this.dialog_passwordSettings=this.settings.options.settingsPasswordRequired=='0'?false:true;
                  if(this.$route.query.pageId)
                  {
                    this.activateComponent(this.items.find(i=>i.pageId==this.$route.query.pageId))
                  }
                  console.log(315,this.items)
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }
            this.loading= false;
        } catch(e)
        {
            this.loading= false;

        }
      },
    async saveItem(p)
    {
        console.log(144,p)
        //this.editedItem2.closedOn=this.editedItem2.closedOn?this.editedItem2.closedOn.join(','):null;
        this.loading_update=true;
        p.WA_Logo=p.brand
        let table=p.demo==0?'SetUp_Demo':'SetUp';
        var z={}
        for (const key in p) {

          z[key]=p[key]===true?1:p[key]===false?0:p[key];
        }
        let payload={"action":"saveItem","table":table,"payload":z};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.dialog_setup=false
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.snackbar_message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        this.editedItem2={}
    },
    async checkPWD(p)
    {
        console.log(290,p)
        this.loading_update=true;
        let payload={"action":"settingsPWD_get","payload":{'settingsPWD':p}};
        console.log(294,payload)
        
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(304,w,w.payloads.validPassword.validPWD);
        if(w.errorid=='0'&&w.payloads.validPassword.validPWD==1)
        {
            this.snackbar_color="success"
            this.snackbar_message ='Password Valida';
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.dialog_passwordSettings=false;
            this.validSettingsPassword=true;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }
        else
        {
          this.snackbar_color="error"
          this.snackbar_message ='Password Errata';
          this.snackbar = true;          
          this.$router.push('/manage').catch(() => {});
        }  
        
    },    
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            //this.snackbar_color='success';
            //this.snackbar_message=res.data.payloads.message;
            //this.getData('refresh')

              if (res.data.message)
              {
                  console.log(333);
                  //this.snackbar=true;
              }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.payloads.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          console.log(e);
          this.loading= false;
          this.dialog_connection_error=true;
        }
    },          
  }
}
</script>